import { cn } from "tools/ui";

const formatter = Intl.NumberFormat("es-CO");
const EMPTY_IMG =
  "https://www.shutterstock.com/image-vector/image-icon-600nw-211642900.jpg";

const card =
  "h-50 w-80 flex mb-2 bg-white cursor-pointer shadow-md shadow-neutral-300 active:scale-95 active:shadow-xl rounded-3xl";

function CardPromotion({ data, handleClick }) {
  return (
    <div className="block max-w-80">
      <div className={cn(card)} onClick={() => handleClick(data)}>
        <img
          className="rounded-2xl w-full object-cover"
          src={data.photo || EMPTY_IMG}
          alt={data.name}
        />
      </div>
      <div className="grid mx-2 text-sm">
        <span className="text-neutral-700 font-bold">{data.name}</span>
        <span className="text-neutral-600">
          Desde ${formatter.format(data.price)} COP
        </span>
        <span className="text-neutral-700 font-bold">{data.rating}</span>
      </div>
    </div>
  );
}

export default CardPromotion;
